import { render } from "./toggleweekends.widget.wp.vue?vue&type=template&id=30806136&scoped=true"
import script from "./toggleweekends.widget.wp.vue?vue&type=script&lang=js"
export * from "./toggleweekends.widget.wp.vue?vue&type=script&lang=js"

import "./toggleweekends.widget.wp.vue?vue&type=style&index=0&id=30806136&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30806136"]])

export default __exports__